let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2jC6U")).then(() => parcelRequire('3xzAj'));